import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { SwitchNum } from '@umu/umu-types';

export interface IInput {
    accounts: string;
    search_source: string;
	is_suggestion?: SwitchNum;
	[key: string]: any;
}

export interface IAccount {
    umu_id: string;
    user_name: string;
    avatar: string;
    email: string;
    account: string;
	phone: string;
	login_name: string;
	account_type: string
}

/**
 * @desc 搜索用户
 * @param data 
 * @returns IResponse<IAccount[]>
 */
export const searchAccount = (data: IInput) => {
    return fetchData(Api.ACCOOUNT_SEARCH, data).then((res: IResponse<IAccount[]>) => {
        return res.data || [];
    }, () => []);
};
